<script setup>
import Button from "@/Components/Button.vue";
import {computed, ref, watch} from "vue";
import InputLabel from "@/Components/InputLabel.vue";
import {
    getStoredSorting,
    setStoredSorting
} from "@/Pages/Education/ReceptionCompany/CompetitionLists/competitionListUtils";

const show = ref(false);

const props = defineProps(['modelValue', 'isPay', 'rcType']);
const emits = defineEmits(['update:modelValue']);

const sortVariants = computed(() => {
    const variants = [
        {'key': 'standard', 'name': 'По рейтингу'},
    ];

    // if(props.rcType?.sys_name === 'BACHELOR' && !props.isPay) return variants;

    variants.push({'key': 'agree', 'name': props.isPay ? 'По договору и оплате' : 'По согласиям на зачисление'});

    if (props.rcType?.sys_name !== 'SVE') {
        variants.push({'key': 'agree-and-priority', 'name': props.isPay ? 'По договору, оплате и приоритету' : 'По согласиям на зачисление и приоритету'});
        variants.push({'key': 'priority', 'name': 'По приоритету'});
        variants.push({'key': 'upper-priority', 'name': 'По высшему проходному приоритету'});
    }

    if (props.rcType?.sys_name === 'SVE') {
        variants.push({'key': 'original', 'name': 'По оригиналам'});
    }

    return variants;
});

const modelValueProxy = computed({
    get() {
        if(sortVariants.value.filter((e) => e.key === props.modelValue).length) {
            return props.modelValue;
        }

        else {
            setStoredSorting('standard');
            return 'standard';
        }
    },
    set(value) { setStoredSorting(value); emits('update:modelValue', value); }
});

watch(() => modelValueProxy.value, (nv) => {
    if(nv !== getStoredSorting()) {
        setStoredSorting(nv);
    }
})

function clickOutsideEvent() { if(show.value) { show.value = false; } }
</script>

<template>
<div class="relative">
    <Button @click.stop.prevent="show = !show" class="b-icon b-primary fas fa-arrow-up-wide-short"/>

    <div v-if="show" v-click-outside="clickOutsideEvent" class="absolute top-[48px] left-0 w-[420px] bg-white border-2 border-primary rounded-xl p-2 flex flex-col gap-2">
        <div v-for="sortVariant in sortVariants" :key="sortVariant.key" class="flex items-center space-x-2">
            <input :id="`filter-${sortVariant.key}`" type="radio" :value="sortVariant.key" v-model="modelValueProxy"/>
            <InputLabel :for="`filter-${sortVariant.key}`">{{  sortVariant.name }}</InputLabel>
        </div>
    </div>
</div>
</template>

<style scoped>

</style>
